(function () {
  var scope = document.getElementById('hb-article-scope');
  if (!scope) return;

  /* ---------------- Table of contents (built from h2s and h3s) ---------------- */

  function slugify(text, used) {
    var base = text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/å/g, 'a')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'osio';
    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i;
      i++;
    }
    used[slug] = true;
    return slug;
  }

  var content = document.getElementById('hb-article-content');
  var tocDesktop = document.getElementById('hb-article-toc-desktop');
  var tocMobile = document.getElementById('hb-article-toc-mobile');
  var tocMobileWrap = document.getElementById('hb-article-toc-mobile-wrap');

  if (content && (tocDesktop || tocMobile)) {
    var headings = content.querySelectorAll('h2, h3');
    var used = {};

    headings.forEach(function (h2, index) {
      if (!h2.id) {
        h2.id = slugify(h2.textContent, used);
      } else {
        used[h2.id] = true;
      }

      var headingText = h2.textContent.trim();
      var alreadyNumbered = /^\d+[.)]\s/.test(headingText);
      var label = alreadyNumbered ? headingText : (index + 1) + '. ' + headingText;

      var linkDesktop = document.createElement('a');
      linkDesktop.href = '#' + h2.id;
      linkDesktop.textContent = label;
      linkDesktop.title = h2.textContent;
      if (tocDesktop) tocDesktop.appendChild(linkDesktop);

      var linkMobile = document.createElement('a');
      linkMobile.href = '#' + h2.id;
      linkMobile.textContent = label;
      linkMobile.title = h2.textContent;
      linkMobile.addEventListener('click', function () {
        if (tocMobileWrap) tocMobileWrap.open = false;
      });
      if (tocMobile) tocMobile.appendChild(linkMobile);
    });

    if (headings.length === 0) {
      var tocCard = document.querySelector('.hb-article__toc-card');
      if (tocCard) tocCard.style.display = 'none';
      if (tocMobileWrap) tocMobileWrap.style.display = 'none';
    }
  }

  /* ---------------- Product card add-to-cart (mid-article + sidebar) ---------------- */

  document.querySelectorAll('[data-hb-article-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('button');
      var label = button.querySelector('span');
      var defaultLabel = label ? label.getAttribute('data-default-label') : '';

      if (button.disabled || button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || 'Add to cart failed');
            });
          }
          return response.json();
        })
        .then(function () {
          button.classList.remove('is-loading');
          if (label) label.textContent = ((window.hbStrings || {}).addedCheck || 'Lisätty ✓');

          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function () {
            if (label) label.textContent = defaultLabel;
          }, 2000);
        })
        .catch(function () {
          button.classList.remove('is-loading');
          if (label) label.textContent = ((window.hbStrings || {}).error || 'Virhe — yritä uudelleen');
          setTimeout(function () {
            if (label) label.textContent = defaultLabel;
          }, 2000);
        });
    });
  });
})();
